import { render } from "./WhoAlphaLabs01.vue?vue&type=template&id=14e41b1e&scoped=true"
const script = {}

import "./WhoAlphaLabs01.vue?vue&type=style&index=0&id=14e41b1e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14e41b1e"]])

export default __exports__